
import { ResumeProfile } from '@/models/Resume';
import { defineComponent, PropType } from 'vue';

export default defineComponent({
    name: "profile",
    props: {
        profile: {
            type: Object as PropType<ResumeProfile>,
            required: true
        } 
    }
})

